module.exports = __webpack_public_path__ + "assets/f6b5ef2193b53d24cb0a68374202ce7c.png";